import { CircularProgress } from '@mui/material';

export const VibLoadingOverlay = () => (
  <section className="grid h-screen place-items-center">
    <CircularProgress className="center" />
  </section>
);
